function initMap() {
    var office_melbourne = {
        lat: -37.81694078851431,
        lng: 144.95767599716845
    };
    // var office_sydney = {
    //     lat: -33.8685275,
    //     lng: 151.2069204
    // };
    var office_brisbane = {
        lat: -27.468409440338295,
        lng: 153.02485389999998
    };


    // var office_perth = {
    //     lat: -31.9541572,
    //     lng: 115.8541792
    // };
    var office_gold_coast = {
        lat: -27.965704330658237,
        lng: 153.41223346973703
    };


    var map_style = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        }, {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        }, {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        }, {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        }, {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }, {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        }, {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ];

var map_melbourne = new google.maps.Map(document.getElementById('map-melbourne'), {
    zoom: 14,
    center: office_melbourne,
    scrollwheel: false,
    styles: map_style
});

// var map_sydney = new google.maps.Map(document.getElementById('map-sydney'), {
//     zoom: 15,
//     center: office_sydney,
//     scrollwheel: false,
//     styles: map_style
// });

var map_brisbane = new google.maps.Map(document.getElementById('map-brisbane'), {
    zoom: 15,
    center: office_brisbane,
    scrollwheel: false,
    styles: map_style
});

// var map_perth = new google.maps.Map(document.getElementById('map-perth'), {
//     zoom: 15,
//     center: office_perth,
//     scrollwheel: false,
//     styles: map_style
// });

var map_gold_coast = new google.maps.Map(document.getElementById('map-gold-coast'), {
    zoom: 15,
    center: office_gold_coast,
    scrollwheel: false,
    styles: map_style
});

var marker_melbourne = new google.maps.Marker({position: office_melbourne, map: map_melbourne, icon: custom_map_marker});

// var marker_sydney = new google.maps.Marker({position: office_sydney, map: map_sydney, icon: custom_map_marker});

var marker_brisbane = new google.maps.Marker({position: office_brisbane, map: map_brisbane, icon: custom_map_marker});

// var marker_perth = new google.maps.Marker({position: office_perth, map: map_perth, icon: custom_map_marker});

var marker_gold_coast = new google.maps.Marker({ position: office_gold_coast, map: map_gold_coast, icon: custom_map_marker });
}

	//contact tabs


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a[data-target]').forEach(function(element) {
        element.addEventListener('click', function(event) {
            event.preventDefault();
            var targetContent = '#' + this.getAttribute('data-target');

            document.querySelectorAll('.tab-buttons a').forEach(function(link) {
                link.classList.remove('active');
            });
            this.classList.add('active');

            document.querySelectorAll('.contact-tab-content').forEach(function(content) {
                content.classList.remove('active');
            });
            document.querySelector(targetContent).classList.add('active');

            initMap();
            return false;
        });
    });

    var tabContent1 = document.querySelector('a[data-target="tab-content-1"]');

    if (tabContent1) {
        tabContent1.click();
    }
   
    // alert('Hello from contact.js!');
});